import { Logo } from "@rosc/ui/v32/logo";
import type { JSX } from "react";

// The ROSC mark with the wordmark: @rosc/ui's Logo
// (packages/ui/src/v32/logo.tsx) with the app's logo file.
export const V3Logo = (props: {
  size?: number;
  wordmark?: boolean;
  className?: string;
}): JSX.Element => (
  <Logo src={`${import.meta.env.BASE_URL}images/logos/logo.svg`} {...props} />
);
